import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { catchError, of } from 'rxjs';
import { applicationUser, AuthenticationService } from 'src/app/auth/services/authentication.service';
import { UserState } from 'src/app/auth/services/user-state.service';
import { NotificationService } from 'src/app/shared/layout/Toaster/NotificationService';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css'],
})
export class ChangePasswordComponent implements OnInit {
  @Output() onSuccess = new EventEmitter<any>();

  form: FormGroup = new FormGroup({
    oldPassword: new FormControl('', Validators.required),
    newPassword: new FormControl('', Validators.required),
    confirmNewPassword: new FormControl('', Validators.required),
    userId: new FormControl(''),
    isEmailConfirmed: new FormControl(''),
    isLoginFirstTime: new FormControl(false),
  });

  loginErrorMsg = '';
  isSubmitted = false;
  loading = false;
  userInfo: applicationUser;

  constructor(
    private authSrv: AuthenticationService,
    private toasterService: NotificationService,
    private userState: UserState
  ) {}

  ngOnInit() {

    this.userState.currentUser$.subscribe((user: applicationUser) => {
      if (user) {
        this.userInfo = user;
      }
    });
  }

  onSubmit() {
    this.isSubmitted = true;
    this.loginErrorMsg = '';
    if (this.form.invalid) return;

    const payload = {
      ...this.form.value,
      userId: this.userInfo.id,
      isEmailConfirmed: this.userInfo.isEmailConfirmed,
      isLoginFirstTime: this.userInfo.isFirstLogin,
    }

    if(payload.confirmNewPassword != payload.newPassword) {
      this.loginErrorMsg = 'New Password & Confirm Password is not Matched'
      return
    }



    this.loading = true;
    this.authSrv
      .changePassword(payload)
      .pipe(
        catchError((error) => {
          console.log(error);
          this.loginErrorMsg = error.error.message;
          this.loading = false;
          return of(null);
        })
      )
      .subscribe((res) => {
        this.loading = false;
        if (res != null) {
          this.toasterService.showSuccess(
            'Success!',
            'Password has been changed'
          );
          this.onSuccess.emit(true);
        }
      });
  }
}
